import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, Platform } from '@ionic/angular';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { ModalFormParentComponent } from '../../modal-forms/modal-form-parent/modal-form-parent.component';

import has from 'lodash/has';
import { UtilityClass } from 'src/app/api/utils/UtilityClass';

@Component({
  selector: 'hub-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
})
export class LoginModalComponent extends ModalFormParentComponent implements OnInit {
  @ViewChild('btnContainer', { static: true }) btnContainer: ElementRef;

  /** The default email to set */
  @Input() defaultEmail: string;

  /** The parent form group */
  public formGroup: FormGroup = new FormGroup({});

  /** The email form control */
  public emailCtrl: FormControl = new FormControl('', [Validators.required, Validators.email]);

  /** The password form control */
  public passwordCtrl: FormControl = new FormControl('', [Validators.required]);

  /** Flagger to indicate the authentication */
  public authenticating: boolean = false;

  /** The error message to show */
  public message: string = '';

  constructor(
    public modalCtrl: ModalController,
    public auth: AuthService,
    public platform: Platform,
    public renderer: Renderer2,
  ) {
    super(platform, modalCtrl, renderer);

    // intialise the form group
    this.formGroup.addControl('email', this.emailCtrl);
    this.formGroup.addControl('password', this.passwordCtrl);
  }

  ngOnInit() {
    super.ngOnInit();
    this.keyboardParentTarget = this.btnContainer;

    // fallback in case the ngOnChange failed
    // set the default email if available and VALID
    if (UtilityClass.validateEmail(this.defaultEmail)) {
      this.emailCtrl.setValue(this.defaultEmail);
    }
  }

  ngOnChanges(changes) {
    // set the default email if available and VALID
    if (changes['defaultEmail'] && UtilityClass.validateEmail(this.defaultEmail)) {
      if (this.emailCtrl) {
        this.emailCtrl.setValue(this.defaultEmail);
      }
    }
  }

  /**
   * Makes an HTTP call to verify the email and password
   */
  async authenticate() {
    // validate the form
    if (this.formGroup.invalid || this.authenticating) {
      return;
    }

    this.authenticating = true;

    const credentials: any = {
      email: this.emailCtrl.value,
      password: this.passwordCtrl.value,
    };

    // store the new value
    const authentication = await this.auth.authenticate(credentials, false);
    this.authenticating = false;
    if (authentication && has(authentication, 'success')) {
      if (authentication.success) {
        this.close(authentication);
        this.message = '';
      } else {
        this.message = "Oops, we can't find that email/password combination.";
      }
    } else {
      this.message = "We're having problems connecting to our server. Please try again later.";
    }
  }

  forgotPassword($event) {
    if ($event) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
    }

    this.modalCtrl.dismiss({
      forgotPassword: true,
    });
  }

  close(result: any | boolean) {
    this.modalCtrl.dismiss(result);
  }
}
